import { AppSidebar } from '@/shared/components/AppSidebar'
import React, { ComponentProps } from 'react'
import { cn } from '../lib/utils'
import { SidebarProvider } from './SidebarProvider'

type SidebarLayoutProps = ComponentProps<'div'> & {
  children: React.ReactNode
  header?: React.ReactNode
  noSidebarToggle?: boolean
}

export function SidebarLayout({
  children,
  header,
  noSidebarToggle,
  ...props
}: SidebarLayoutProps) {
  return (
    <SidebarProvider>
      <div
        {...props}
        className={cn(
          'SidebarLayout',
          'flex h-full w-full overflow-hidden',
          props.className
        )}
      >
        <AppSidebar showUserMenu noSidebarToggle={noSidebarToggle} />

        <div className="SidebarLayoutContent flex h-full w-full flex-1 flex-col overflow-hidden">
          {header}
          <div className="flex-1 overflow-y-auto">{children}</div>
        </div>
      </div>
    </SidebarProvider>
  )
}
